export class Constants {
  static appName = 'Cratebase';
}

export interface CrateColor {
  name: string;
  hex: string;
  isDefault: boolean;
}

// Default fallback colors (will be replaced by API data)
export const FALLBACK_CRATE_COLORS: CrateColor[] = [
  { name: 'green', hex: '#248a42', isDefault: true },
  { name: 'orange', hex: '#f97316', isDefault: false },
  { name: 'red', hex: '#ef4444', isDefault: false },
  { name: 'blue', hex: '#3b82f6', isDefault: false },
  { name: 'purple', hex: '#433197', isDefault: false },
  { name: 'yellow', hex: '#fbbf24', isDefault: false },
  { name: 'gray', hex: '#6b7280', isDefault: false },
];

export const DEFAULT_CRATE_COLOR_NAME = 'green';
export const DEFAULT_CRATE_COLOR_HEX = '#248a42';
